module.exports = __webpack_public_path__ + "static/media/Getty_Images_160375427_desktop.7214e698.jpg";